import {
    useMemo,
} from 'react'
import {
    ActionLinkFunction,
} from 'app/types/form.types'
import useStyles from './ActionLink.styles'

type Props = {
    actionLinkFunction: ActionLinkFunction,
    children: JSX.Element,
    className?: string,
}
const defaultProps: Partial<Props> = {
    className: undefined,
}

const ActionLink = ({
    actionLinkFunction,
    children,
    className,
}: Readonly<Props>) => {
    const {
        classes,
        cx,
    } = useStyles()

    const actionLinks = useMemo(() => {
        return actionLinkFunction?.() || []
    }, [actionLinkFunction])

    return (
        <div className={cx(className, classes.container)}>
            {children}
            {actionLinks?.length > 0 ? (
                <div className={classes.actionLinksContainer}>
                    {actionLinks.map((actionLink) => {
                        return actionLink
                    })}
                </div>
            ) : null}
        </div>
    )
}

ActionLink.defaultProps = defaultProps

export default ActionLink
